import React from 'react'

const SmallBanner = ({ content }) => {
  return (
    <div className='
        bg-banner bg-cover bg-center bg-no-repeat h-[calc(50svh-6rem)] 
        p-4 sm:p-8 md:p-24 flex justify-center 
        items-center
    '>
      <div className='text-base-100'>
        {content}
      </div>
    </div>
  )
}

export default SmallBanner